export const SWAYY_PRODUCT_ATTRIBUTE_KEYS = [
  "priority",
  "length",
  "breadth",
  "height",
  "weight",
] as const;

export type SwayyProductAttributeKey =
  (typeof SWAYY_PRODUCT_ATTRIBUTE_KEYS)[number];

export type SwayyProductAttributeFields = Record<
  SwayyProductAttributeKey,
  string
>;

export const emptyProductAttributeFields = (): SwayyProductAttributeFields => ({
  priority: "",
  length: "",
  breadth: "",
  height: "",
  weight: "",
});

const asAttrString = (value: unknown): string => {
  if (value == null || value === "") return "";
  return String(value);
};

export const parseProductAttributeFields = (
  raw: unknown,
): SwayyProductAttributeFields => {
  const source =
    raw && typeof raw === "object" && !Array.isArray(raw)
      ? (raw as Record<string, unknown>)
      : {};
  return {
    priority: asAttrString(source.priority),
    length: asAttrString(source.length),
    breadth: asAttrString(source.breadth),
    height: asAttrString(source.height),
    weight: asAttrString(source.weight),
  };
};

export const parseOptionalAttributeNumber = (
  value: string,
): number | null => {
  const trimmed = value.trim();
  if (!trimmed) return null;
  const parsed = Number(trimmed);
  return Number.isFinite(parsed) ? parsed : null;
};

export const asAttributeRecord = (
  raw: unknown,
): Record<string, unknown> => {
  if (raw && typeof raw === "object" && !Array.isArray(raw)) {
    return { ...(raw as Record<string, unknown>) };
  }
  return {};
};

/** Merge Swageazy-style fields into existing product.attributes JSON. */
export const buildProductAttributesPayload = (
  fields: SwayyProductAttributeFields,
  existing: unknown,
): Record<string, unknown> | null => {
  const next = asAttributeRecord(existing);
  for (const key of SWAYY_PRODUCT_ATTRIBUTE_KEYS) {
    const parsed = parseOptionalAttributeNumber(fields[key]);
    if (parsed === null) {
      delete next[key];
    } else {
      next[key] = key === "priority" ? Math.trunc(parsed) : parsed;
    }
  }
  return Object.keys(next).length > 0 ? next : null;
};

export const haveAttributeFieldsChanged = (
  current: SwayyProductAttributeFields,
  original: SwayyProductAttributeFields,
): boolean =>
  SWAYY_PRODUCT_ATTRIBUTE_KEYS.some(
    (key) => current[key].trim() !== original[key].trim(),
  );
